import { render, staticRenderFns } from "./AdminServicesView.vue?vue&type=template&id=a6b8d786"
import script from "./AdminServicesView.vue?vue&type=script&lang=js"
export * from "./AdminServicesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports